import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  promotionalHeader: {
    id: 'drXOXY',
    defaultMessage: 'Search and compare our discounted rates.',
    description: 'Header text for single-label promotional section',
  },
  promotionalSubtext: {
    id: 'iKuhDT',
    defaultMessage: 'Save up to 90% on the carriers you use every day',
    description: 'Subtext for single-label promotional section',
  },
  carrierLogosAlt: {
    id: 'fU0laQ',
    defaultMessage: 'Carrier logos for UPS, USPS, FedEx, DHL, and ShipStation',
    description: 'Alt text for carrier logos image',
  },
});
